<div>
  <form [formGroup]="form" >
    <div class="header-navigation-back">
      <mat-icon (click)="goBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
      <span class="title" data-test="edit-button">Edit Profile</span>
    </div>
    <div class="content">
      @if (loading) {
        <app-loading-gif></app-loading-gif>
      }
      <div
        class="component-container padding-top-md" [hidden]="loading">
        <div>
          <div class="profile-container" >
            <img [src]="profilePicture" class="profile-image" />
            <mat-icon svgIcon="edit-icon" class="edit-icon" (click)="onNavigateToProfilePicture()"
            data-test="add-profile-pic"></mat-icon>
          </div>
        </div>
        <div  class="personal-info-title">
          Personal Info
        </div>
        <div  class="personal-form-field" data-test="driver-info">
          <div >
            <mat-form-field class="full-width">
              <input matInput autocomplete="off" #firstName placeholder="First Name" formControlName="firstName" required
                data-testid="name-form-field" data-test="name-form-field"/>
            </mat-form-field>
          </div>
          <div >
            <mat-form-field class="full-width">
              <input matInput placeholder="Last Name" autocomplete="off" formControlName="lastName" required
                data-test="name-form-field" />
            </mat-form-field>
          </div>
          <div >
            <mat-form-field class="full-width">
              <input matInput placeholder="Date Of Birth" [matDatepicker]="dateOfBirth" formControlName="dateOfBirth"
                [max]="maxDate" required (click)="onDatePickerClick(dateOfBirth)" (focus)="onDatePickerClick(dateOfBirth)"/>
              <mat-datepicker-toggle matSuffix [for]="dateOfBirth" data-test="dob-form-field"></mat-datepicker-toggle>
              <mat-datepicker touchUi="true" #dateOfBirth></mat-datepicker>
              <mat-error>
                {{ getDateOfBirthErrorMessage() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div >
            <mat-form-field class="full-width">
              <mat-label>Gender*</mat-label>
              <mat-select formControlName="gender" data-test="gender-form-field">
                <mat-option value="male" data-test="gender-value">Male</mat-option>
                <mat-option value="female" data-test="gender-value">Female</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div  class="personal-info-title">
          Contact
        </div>
        <div  class="contact-form-field">
          <!-- Google Address Lookup — always use autocomplete -->
          <!-- Manual address toggle commented out — Google autocomplete covers 99%+ of addresses
          <div class="turnoff-text" (click)="onGoogleAddressLookupToggle($event)">
            {{ isGoogleAddressLookupEnabled ? 'Enter Address Manually' : 'Use Address Autocomplete' }}
          </div>
          -->
          <mat-form-field class="full-width">
            <input matInput placeholder="Address" formControlName="address" #addressText required
              data-test="address-field" autocomplete="on" />
            @if (address.touched && address.invalid) {
              <mat-error>
                {{ getAddressErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>
          <!-- Manual address fields removed — Google autocomplete covers 99%+ of addresses.
               See git history to restore if needed. -->
          <mat-form-field class="full-width">
            <mat-label>Work Status*</mat-label>
            <mat-select formControlName="workStatus" data-test="workStatus-form-field">
              @for (status of workStatues; track status) {
                <mat-option [value]="status.name" data-test="workStatus-value">{{
                  status.displayName
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width">
            <mat-label>Phone*</mat-label>
            <input matInput autocomplete="off" placeholder="Phone" appPhoneMask formControlName="phone" maxlength="12"
              data-test="phone-field" />
          </mat-form-field>
          <mat-form-field class="full-width">
            <mat-label>Email</mat-label>
            <input matInput placeholder="email" formControlName="email" disabled="true" readonly />
          </mat-form-field>
        </div>
        <div  class="personal-info-title emergency-contact">
          <div class="emergency-text">
            Emergency Contact(s)
          </div>
          @if (emergencyContacts.length < 2) {
            <div class="add-btn" (click)="addEmergencyContact()">
              <mat-icon class="add-emergency" svgIcon="add-plus-icon"></mat-icon>
            </div>
          }
        </div>
        <div formArrayName="emergencyContacts">
          @for (contact of emergencyContacts.controls; track contact; let i = $index) {
            <div>
              <div class="emergency-contact-title">Emergency Contact {{ i + 1 }}</div>
              <div class="padding-left-sm padding-right-sm margin-bottom-sm"><mat-divider></mat-divider></div>
              <div [formGroupName]="i"  class="contact-form-field">
                <mat-form-field class="full-width">
                  <mat-label>Name *</mat-label>
                  <input matInput autocomplete="off" placeholder="Name" formControlName="emergencyContactName"
                    data-test="name-form-field" />
                </mat-form-field>
                <mat-form-field class="full-width">
                  <mat-label>Relation *</mat-label>
                  <input matInput autocomplete="off" placeholder="Relation" formControlName="emergencyContactRelation"
                    data-test="relation-form-field" />
                </mat-form-field>
                <mat-form-field class="full-width">
                  <mat-label>Phone *</mat-label>
                  <input matInput autocomplete="off" placeholder="Phone" appPhoneMask
                    formControlName="emergencyContactPhone" maxlength="12" data-test="phone-field" />
                </mat-form-field>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </form>
  <div class="fixed-footer">
    <button mat-button class="btn-cancel" (click)="goBack()">Cancel</button>
    <button
      mat-raised-button
      class="btn-save margin-right-sm"
      (click)="onSubmit()"
      [disabled]="(!form.dirty || !form.valid) && !loading"
      data-test="save-button"
      >
      Save
    </button>
  </div>
</div>